import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import {
    PROMOTION_EDITOR_SELECTOR
} from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { PromotionModel } from "../../../datastore/entities/promotion.model";
import { ProductModel } from "../../../datastore/entities/product.model";
import { IDropdownSettings } from "ng-multiselect-dropdown/multiselect.model";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { NurseryModel } from "app/datastore/entities/nursery.model";

@Component({
    selector: PROMOTION_EDITOR_SELECTOR,
    templateUrl: "./promotioneditor.component.html"
})
export class PromotionEditorComponent extends BaseComponent implements OnInit, OnChanges {

    @Output() public promoDelete = new EventEmitter<string>();
    @Output() public promoSave = new EventEmitter<{
        title: string,
        description: string
        products: ProductModel[],
        nurseries: NurseryModel[]
    }>();

    @Input() public editedPromo: PromotionModel;
    @Input() public products: ProductModel[];
    @Input() public nurseryUuid: string;

    public promoName: string;
    public promoDesc: string;

    public selectedItems: ProductModel[];
    public dropdownSettings: IDropdownSettings;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        private photosphereManager: PhotosphereManager,
        protected location: Location,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnChanges() {
        // logData("CHANGES");
        this.init();
    }

    public init() {
        if(this.editedPromo && this.editedPromo.products) {
            const prods: ProductModel[] = [];
            for(const prod of this.editedPromo.products) {
                // logData("PROD");
                // logData(prod);
                prods.push(prod.product);
            }
            this.selectedItems = prods;
        } else {
            this.selectedItems = [];
        }
        this.dropdownSettings = {
            singleSelection: false,
            idField: "uuid",
            textField: "name",
            enableCheckAll: false,
            allowSearchFilter: true
        };

        if(this.editedPromo) {
            this.promoName = this.editedPromo.title;
            this.promoDesc = this.editedPromo.description;
        }
    }

    public onPromoDelete() {
        this.promoDelete.emit();
    }

    public onPromoSave() {
        let currentNursery;
        if (this.nurseryUuid) {
            currentNursery = new NurseryModel("");
            currentNursery.uuid = this.nurseryUuid;
        }
        this.promoSave.emit({
            title: this.promoName,
            description: this.promoDesc,
            products: this.selectedItems,
            nurseries: [
                currentNursery
            ]
        });
    }

    onItemSelect(_: unknown) {
        // empty
    }

    onSelectAll(_: unknown) {
        // empty
    }
}